export function formatDisplayDate(
  value: unknown,
  locale: string = 'es-AR',
): string {
  if (value == null || value === '') {
    return '—';
  }
  const d =
    value instanceof Date ? value : new Date(typeof value === 'string' || typeof value === 'number' ? value : String(value));
  if (Number.isNaN(d.getTime())) {
    return '—';
  }
  return d.toLocaleDateString(locale);
}
